import createReducer from 'Lib/createReducer';

export const CREATE_MARKERS = 'CREATE_MARKERS';
export const DELETE_MARKERS = 'DELETE_MARKERS';
export const SAVE_MARKERS = 'SAVE_MARKERS';

export const createMarkers = markers => {
  return {
    type: CREATE_MARKERS,
    data: markers
  };
};

export const deleteMarkers = markers => {
  return {
    type: DELETE_MARKERS,
    data: markers
  };
};

export const saveMarkers = markers => {
  return {
    type: SAVE_MARKERS,
    data: markers
  };
};


const initialState = [];

const actionHandlers = {
  [SAVE_MARKERS]: (state, action) => {
    return [ ...action.data ];
  }
};


export default createReducer(initialState, actionHandlers);
